import React from 'react';
import styled from 'styled-components';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { getNumberValue } from '../../../../helpers/Number';

const Style = styled.div`
  display: flex;
  gap: 10%;
  flex-wrap: wrap;

  .item {
    gap: 8px;
    flex: 1;
    display: flex;
    justify-content: space-between;
    border-radius: 8px;

    label {
      margin-bottom: 0px;
      color: #344054;
    }

    .item-header {
      display: flex;
      gap: 12px;
      justify-content: center;

      .label {
        label {
          font-size: var(--font-size-lg);
          font-weight: 500;
        }
      }
    }
      
    .value {
      display: flex;
      justify-content: center;

      label {
        font-size: var(--font-size-lg);
        font-weight: 500;

      }

      .label {
        color: white;
        padding: 2px 10px;
        border-radius: 16px;
        font-size: 14px;
        font-weight: 500;

        span {
          margin-bottom: 0px;
        }

        &.very-high-score {
          background: #CF1322;
        }

        &.high-score {
          background: #FF4D4F;
        }

        &.medium-score {
          background: #FA8C16;
        }

        &.low-score {
          background: #FADB14;
        }

        &.very-low-score {
          background: #73D13D;
        }

        &.none-score {
          background: #f1f1f1;
          color: #344054;
        }
      }
    }

    &.max-width {
      max-width: 200px;
    }
  }
`;

const getScoreValue = (values, score, t) => {
  if (score === 0) {
    return (
      <div className="label none-score">
        <span>{t('None')}</span>
      </div>
    );
  } else if (score <= values[0]) {
    return (
      <div className="label very-low-score">
        <span>{t('Very Low')}</span>
      </div>
    );
  } else if (score <= values[1]) {
    return (
      <div className="label low-score">
        <span>{t('Low')}</span>
      </div>
    );
  } else if (score <= values[2]) {
    return (
      <div className="label medium-score">
        <span>{t('Medium')}</span>
      </div>
    );
  } else if (score <= values[3]) {
    return (
      <div className="label high-score">
        <span>{t('High')}</span>
      </div>
    );
  } else if (score <= values[4]) {
    return (
      <div className="label very-high-score">
        <span>{t('Very High')}</span>
      </div>
    );
  }
  return null;
};

const getValue = (item, t) => {
  if (!item.value) {
    return (
      <label>--</label>
    );
  }

  switch (item.type) {
    case 'riskScore':
      return getScoreValue([1, 2, 3, 4, 5], item.value, t);
    case 'riskScoreSupplyChain':
      return getScoreValue([20, 40, 60, 80, 100], item.value, t);
    default:
      return (
        <label>{getNumberValue(item.value || '--')}</label>
      );
  }
};

const Metrics = ({
  items = [],
  t = (s) => s,
}) => (
  <Style>
    {items.map((item) => (
      <div key={`metrics-${item.key}`} className={formatClassname(['item', item.className])}>
        <div className="item-header">
          <div className="label flex-c jus-c">
            <label>{item.label}</label>
          </div>
        </div>
        <div className="value">
          {getValue(item, t)}
        </div>
      </div>
    ))}
  </Style>
);

export default Metrics;
